import React, {
  useEffect,
  useState,
  cloneElement,
  isValidElement,
} from 'react';
import { spread_classes } from '../utils';

import './form.css';

const { map } = React.Children;

const Form = ({
  a11yTitle,
  children,
  tracking = {},
  formId,
  server,
  report,
}) => {
  if (!a11yTitle) throw new Error('please provide a title for the form');
  const [ioValues, setIOValues] = useState(tracking);

  useEffect(() => {
    report && report(ioValues);
  }, [ioValues]);

  const onUpdate = (k, v) => {
    setIOValues(ioValues => ({
      ...ioValues,
      [k]: v,
    }));
  };

  const baseProps = props => ({
    ...props,
    initial: ioValues[props.name],
    server: server && server.type === props.name ? server : null,
    onUpdate,
  });

  const buttonProps = props => ({ ...props });

  const spreadProps = c => {
    const { name } = c.type;
    if (name === 'Button' || name === 'ButtonToggle') {
      return {
        ...buttonProps(c.props),
      };
    } else {
      return {
        ...baseProps(c.props),
      };
    }
  };

  return (
    <>
      <form id={formId} aria-label={a11yTitle} io-form="">
        {map(children, c => {
          // ignore random <div/>s etc.
          if (!isValidElement(c) || typeof c.type === 'string') {
            return c;
          }
          return cloneElement(c, spreadProps(c));
        })}
      </form>
    </>
  );
};

Form.displayName = 'IOForm';
export default Form;
